import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToTop component that automatically scrolls to the top of the page
 * when the route changes. This improves UX by ensuring users start at the
 * top of each new page rather than maintaining scroll position from previous page.
 *
 * Note: This targets the .app-layout container since that's where the overflow-y: auto is set,
 * not the window/body which has overflow: hidden.
 */
export const ScrollToTop = (): null => {
  const { pathname } = useLocation()

  useEffect(() => {
    // Find the scrollable container (.app-layout)
    const scrollableContainer = document.querySelector('.app-layout')

    if (scrollableContainer) {
      // Scroll the container to top
      scrollableContainer.scrollTo(0, 0)
    } else {
      // Fallback to window scroll if container not found
      window.scrollTo(0, 0)
    }
  }, [pathname])

  // This component doesn't render anything
  return null
}
